// // hooks/species/useTreeSpeciesDetail.js
// import { useState, useEffect, useCallback } from "react";
// import { getTreeSpeciesDetailApi } from "../../apis/treeSpeciesApi";

// export const useTreeSpeciesDetail = (speciesId) => {
//   const [detail, setDetail] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const fetchDetail = useCallback(async () => {
//     if (!speciesId) return;

//     setLoading(true);
//     setError(null);

//     try {
//       const response = await getTreeSpeciesDetailApi(speciesId);
//       // ── IMPORTANT FIX ──
//       const speciesData = response?.data || response;   // handle both {data: {...}} and direct object
//       setDetail(speciesData);
//     } catch (err) {
//       const msg = err.message || "Failed to load species details";
//       setError(msg);
//       console.error("Detail fetch failed:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [speciesId]);

//   useEffect(() => {
//     if (speciesId) fetchDetail();
//   }, [speciesId, fetchDetail]);

//   return { detail, loading, error, refetch: fetchDetail };
// };
// hooks/species/useTreeSpeciesDetail.js
import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { getTreeSpeciesDetailApi } from "../../apis/treeSpeciesApi";

export const useTreeSpeciesDetail = (speciesId) => {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
    // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to load species details.",
    };
  };

  const fetchDetail = useCallback(async (silent = true) => {
    if (!speciesId) return;

    setLoading(true);
    setError(null);

    let toastId = null;
    if (!silent) {
      toastId = toast.loading("Loading species details...");
    }

    try {
      const response = await getTreeSpeciesDetailApi(speciesId);

      // Handle both { data: {...} } and direct object
      const speciesData = response?.data || response;

      setDetail(speciesData);

      if (toastId) {
        toast.update(toastId, {
          render: (
            <div>
              <strong>Success</strong>
              <div>Species details loaded successfully.</div>
            </div>
          ),
          type: "success",
          isLoading: false,
          autoClose: 1500,
        });
      }
    } catch (err) {
      const { title, issue } = extractError(err);

      if (toastId) {
        toast.update(toastId, {
          render: (
            <div>
              <strong>{title}</strong>
              <div>{issue}</div>
            </div>
          ),
          type: "error",
          isLoading: false,
        });
      } else {
        toast.error(
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        );
      }

      setError({ title, issue });
      console.error("Detail fetch failed:", err);
    } finally {
      setLoading(false);
    }
  }, [speciesId]);

  useEffect(() => {
    if (speciesId) fetchDetail(true); // silent on mount
  }, [speciesId, fetchDetail]);

  return { detail, loading, error, refetch: () => fetchDetail(false) };
};